import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import store from "../stores/store";
import { setError } from "../../pages/error/errorNotice/errorNoticeSlice";
import { setClsMiddlewareApplicationLog } from "../../services/log/logOptions";
import { requestLogMapper } from "./mappers/requestLogMapper";
import { responseLogMapper } from "./mappers/responseLogMapper";
import { ErrorDataPayload, errorDataResponseSchema } from "../../models/errors/errorResponse";
import { addErrorLog } from "../slices/logSlice";
import { isCustomMetaAction, isValidErrorPayload } from "../../services/api/rtkTypeGuardChecks";

export const errorLoggerMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action) && isCustomMetaAction(action) && isValidErrorPayload(action.payload)) {
    const { requestId, baseQueryMeta } = action.meta || {};
    const { request, response } = baseQueryMeta || {};
    const mappedRequest = request ? requestLogMapper(request) : undefined;
    const mappedResponse = response ? responseLogMapper(response) : undefined;

    const payload = action.payload;

    // Auth
    if (payload?.status === 401) {
      return next(action);
    }

    const errorMsg = `${action?.error?.message}. ${JSON.stringify(payload)}`;

    store.dispatch(
      addErrorLog({
        errorMsg,
        clsLog: setClsMiddlewareApplicationLog({
          requestId: requestId,
          request: mappedRequest,
          response: mappedResponse,
        }),
      })
    );

    const isCustomErrorType = errorDataResponseSchema.safeParse(payload).success;

    if (isCustomErrorType) {
      store.dispatch(
        setError({
          type: "async",
          backendType: payload.data.code,
          message: (payload.data as ErrorDataPayload).reason,
        })
      );
    } else {
      store.dispatch(setError({ type: "async", message: errorMsg }));
    }
  }
  return next(action);
};
